import { CSSProperties } from 'react';
import { CalendarEvent } from '../../types/calendar';

export function getEventStyle(
  event: CalendarEvent,
  redesignActive: boolean,
  openedAppointmentId?: string,
) {
  const isSelected =
    redesignActive &&
    event.type === 'appointment' &&
    event.appointmentId === openedAppointmentId;
  const railColor =
    redesignActive && event.type === 'appointment'
      ? event.railColor
      : undefined;
  return {
    style: {
      backgroundColor: event.color,
      ...(isSelected && { boxShadow: '0 0 0 2px #000' }),
      // Consumed by styles.css so the canceled !important border keeps it.
      ...(railColor && { '--appt-rail': railColor }),
    } as CSSProperties,
  };
}
